export const MODELS = {
    "Account": {
        "class_name": "App\\Models\\Account"
    },
    "AccountClosedReason": {
        "class_name": "App\\Models\\AccountClosedReason"
    },
    "AccountVerification": {
        "class_name": "App\\Models\\AccountVerification"
    },
    "Activity": {
        "class_name": "App\\Models\\Activity"
    },
    "AddTaskAutomation": {
        "class_name": "App\\Models\\AddTaskAutomation"
    },
    "Admin": {
        "class_name": "App\\Models\\Admin"
    },
    "AnsweringSequence": {
        "class_name": "App\\Models\\AnsweringSequence"
    },
    "AnsweringSequenceStep": {
        "class_name": "App\\Models\\AnsweringSequenceStep"
    },
    "Appointment": {
        "class_name": "App\\Models\\Appointment"
    },
    "AppointmentAttendee": {
        "class_name": "App\\Models\\AppointmentAttendee"
    },
    "AppointmentReminder": {
        "class_name": "App\\Models\\AppointmentReminder"
    },
    "AppointmentReminderAttendee": {
        "class_name": "App\\Models\\AppointmentReminderAttendee"
    },
    "BaseModel": {
        "class_name": "App\\Models\\BaseModel"
    },
    "BillingPlanChangeLog": {
        "class_name": "App\\Models\\BillingPlanChangeLog"
    },
    "BuyingOffer": {
        "class_name": "App\\Models\\BuyingOffer"
    },
    "CallScript": {
        "class_name": "App\\Models\\CallScript"
    },
    "CallScriptStep": {
        "class_name": "App\\Models\\CallScriptStep"
    },
    "CallrailTextLog": {
        "class_name": "App\\Models\\CallrailTextLog"
    },
    "Campaign": {
        "class_name": "App\\Models\\Campaign"
    },
    "CampaignCost": {
        "class_name": "App\\Models\\CampaignCost"
    },
    "CampaignUnitCount": {
        "class_name": "App\\Models\\CampaignUnitCount"
    },
    "Charge": {
        "class_name": "App\\Models\\Charge"
    },
    "CommunicationLog": {
        "class_name": "App\\Models\\CommunicationLog"
    },
    "Contact": {
        "class_name": "App\\Models\\Contact"
    },
    "ContactContactType": {
        "class_name": "App\\Models\\ContactContactType"
    },
    "ContactType": {
        "class_name": "App\\Models\\ContactType"
    },
    "CustomField": {
        "class_name": "App\\Models\\CustomField"
    },
    "DoNotContactPhoneNumber": {
        "class_name": "App\\Models\\DoNotContactPhoneNumber"
    },
    "EmailAutomation": {
        "class_name": "App\\Models\\EmailAutomation"
    },
    "EmailLog": {
        "class_name": "App\\Models\\EmailLog"
    },
    "EmailSentLog": {
        "class_name": "App\\Models\\EmailSentLog"
    },
    "AccountInfoHasCallRailEnum": {
        "class_name": "App\\Models\\Enums\\AccountInfoHasCallRailEnum"
    },
    "AccountInfoHasLeadPropellerEnum": {
        "class_name": "App\\Models\\Enums\\AccountInfoHasLeadPropellerEnum"
    },
    "AccountInfoHowLongInBusinessEnum": {
        "class_name": "App\\Models\\Enums\\AccountInfoHowLongInBusinessEnum"
    },
    "AccountInfoHowManyDealsEnum": {
        "class_name": "App\\Models\\Enums\\AccountInfoHowManyDealsEnum"
    },
    "AccountInfoTypicalExitStrategyEnum": {
        "class_name": "App\\Models\\Enums\\AccountInfoTypicalExitStrategyEnum"
    },
    "AccountInfoUsedAutomatedFollowUpEnum": {
        "class_name": "App\\Models\\Enums\\AccountInfoUsedAutomatedFollowUpEnum"
    },
    "AccountStatusEnum": {
        "class_name": "App\\Models\\Enums\\AccountStatusEnum"
    },
    "AccountTypeEnum": {
        "class_name": "App\\Models\\Enums\\AccountTypeEnum"
    },
    "ActivityActionEnum": {
        "class_name": "App\\Models\\Enums\\ActivityActionEnum"
    },
    "ActivityTypeEnum": {
        "class_name": "App\\Models\\Enums\\ActivityTypeEnum"
    },
    "AnsweringSequenceStepTypeEnum": {
        "class_name": "App\\Models\\Enums\\AnsweringSequenceStepTypeEnum"
    },
    "AppointmentCancellationTypeEnum": {
        "class_name": "App\\Models\\Enums\\AppointmentCancellationTypeEnum"
    },
    "AppointmentReminderTypeEnum": {
        "class_name": "App\\Models\\Enums\\AppointmentReminderTypeEnum"
    },
    "AutomationHookEnum": {
        "class_name": "App\\Models\\Enums\\AutomationHookEnum"
    },
    "AutomationTypeEnum": {
        "class_name": "App\\Models\\Enums\\AutomationTypeEnum"
    },
    "BillingCycleEnum": {
        "class_name": "App\\Models\\Enums\\BillingCycleEnum"
    },
    "BillingPlanEnum": {
        "class_name": "App\\Models\\Enums\\BillingPlanEnum"
    },
    "BillingSpecialEnum": {
        "class_name": "App\\Models\\Enums\\BillingSpecialEnum"
    },
    "BillingUsageTypeEnum": {
        "class_name": "App\\Models\\Enums\\BillingUsageTypeEnum"
    },
    "BuyingAnalysisTypeEnum": {
        "class_name": "App\\Models\\Enums\\BuyingAnalysisTypeEnum"
    },
    "BuyingInfoStatusEnum": {
        "class_name": "App\\Models\\Enums\\BuyingInfoStatusEnum"
    },
    "BuyingOfferMadeByEnum": {
        "class_name": "App\\Models\\Enums\\BuyingOfferMadeByEnum"
    },
    "BuyingOfferStatusEnum": {
        "class_name": "App\\Models\\Enums\\BuyingOfferStatusEnum"
    },
    "BuyingOfferTypeEnum": {
        "class_name": "App\\Models\\Enums\\BuyingOfferTypeEnum"
    },
    "CalendarIntegrationTypeEnum": {
        "class_name": "App\\Models\\Enums\\CalendarIntegrationTypeEnum"
    },
    "CallLogTypeEnum": {
        "class_name": "App\\Models\\Enums\\CallLogTypeEnum"
    },
    "CallScriptStatusEnum": {
        "class_name": "App\\Models\\Enums\\CallScriptStatusEnum"
    },
    "CallScriptStepFieldTypeEnum": {
        "class_name": "App\\Models\\Enums\\CallScriptStepFieldTypeEnum"
    },
    "CallrailNumberVerificationStatusEnum": {
        "class_name": "App\\Models\\Enums\\CallrailNumberVerificationStatusEnum"
    },
    "CampaignChannelEnum": {
        "class_name": "App\\Models\\Enums\\CampaignChannelEnum"
    },
    "CampaignInboundChannelEnum": {
        "class_name": "App\\Models\\Enums\\CampaignInboundChannelEnum"
    },
    "CampaignOutboundChannelEnum": {
        "class_name": "App\\Models\\Enums\\CampaignOutboundChannelEnum"
    },
    "ClientStoreEnum": {
        "class_name": "App\\Models\\Enums\\ClientStoreEnum"
    },
    "CommunicationDeliveryStatusEnum": {
        "class_name": "App\\Models\\Enums\\CommunicationDeliveryStatusEnum"
    },
    "CommunicationDirectionEnum": {
        "class_name": "App\\Models\\Enums\\CommunicationDirectionEnum"
    },
    "CommunicationTypeEnum": {
        "class_name": "App\\Models\\Enums\\CommunicationTypeEnum"
    },
    "CouponCodeEnum": {
        "class_name": "App\\Models\\Enums\\CouponCodeEnum"
    },
    "CustomFieldTypeEnum": {
        "class_name": "App\\Models\\Enums\\CustomFieldTypeEnum"
    },
    "CustomFieldableTypeEnum": {
        "class_name": "App\\Models\\Enums\\CustomFieldableTypeEnum"
    },
    "DealProbabilityScoreEnum": {
        "class_name": "App\\Models\\Enums\\DealProbabilityScoreEnum"
    },
    "DomainServiceProviderTypeEnum": {
        "class_name": "App\\Models\\Enums\\DomainServiceProviderTypeEnum"
    },
    "EmailIntegrationTypeEnum": {
        "class_name": "App\\Models\\Enums\\EmailIntegrationTypeEnum"
    },
    "Enumerate": {
        "class_name": "App\\Models\\Enums\\Enumerate"
    },
    "ExitStrategyEnum": {
        "class_name": "App\\Models\\Enums\\ExitStrategyEnum"
    },
    "FeatureEnum": {
        "class_name": "App\\Models\\Enums\\FeatureEnum"
    },
    "FixAndFlipSellingInfoStatusEnum": {
        "class_name": "App\\Models\\Enums\\FixAndFlipSellingInfoStatusEnum"
    },
    "FollowUpSequenceStatusEnum": {
        "class_name": "App\\Models\\Enums\\FollowUpSequenceStatusEnum"
    },
    "FollowUpSequenceStepTypeEnum": {
        "class_name": "App\\Models\\Enums\\FollowUpSequenceStepTypeEnum"
    },
    "FollowUpSequenceTemplateEndStepOptionsEnum": {
        "class_name": "App\\Models\\Enums\\FollowUpSequenceTemplateEndStepOptionsEnum"
    },
    "FollowUpSequenceTemplateStatusEnum": {
        "class_name": "App\\Models\\Enums\\FollowUpSequenceTemplateStatusEnum"
    },
    "ForwarderTypeEnum": {
        "class_name": "App\\Models\\Enums\\ForwarderTypeEnum"
    },
    "ImportStatusEnum": {
        "class_name": "App\\Models\\Enums\\ImportStatusEnum"
    },
    "InboundCallCallerIdEnum": {
        "class_name": "App\\Models\\Enums\\InboundCallCallerIdEnum"
    },
    "InboxTypeEnum": {
        "class_name": "App\\Models\\Enums\\InboxTypeEnum"
    },
    "IntegrationTypeEnum": {
        "class_name": "App\\Models\\Enums\\IntegrationTypeEnum"
    },
    "MailGunEventEnum": {
        "class_name": "App\\Models\\Enums\\MailGunEventEnum"
    },
    "MaintenanceProcessStatusEnum": {
        "class_name": "App\\Models\\Enums\\MaintenanceProcessStatusEnum"
    },
    "MotivationEnum": {
        "class_name": "App\\Models\\Enums\\MotivationEnum"
    },
    "OffsetDirectionEnum": {
        "class_name": "App\\Models\\Enums\\OffsetDirectionEnum"
    },
    "PhoneIntegrationTypeEnum": {
        "class_name": "App\\Models\\Enums\\PhoneIntegrationTypeEnum"
    },
    "PusherServiceEventTypeEnum": {
        "class_name": "App\\Models\\Enums\\PusherServiceEventTypeEnum"
    },
    "PusherServiceMethodEnum": {
        "class_name": "App\\Models\\Enums\\PusherServiceMethodEnum"
    },
    "QueueEnum": {
        "class_name": "App\\Models\\Enums\\QueueEnum"
    },
    "QueueableStatusEnum": {
        "class_name": "App\\Models\\Enums\\QueueableStatusEnum"
    },
    "RecordArchiveTypeEnum": {
        "class_name": "App\\Models\\Enums\\RecordArchiveTypeEnum"
    },
    "RecordRoleEnum": {
        "class_name": "App\\Models\\Enums\\RecordRoleEnum"
    },
    "RecordStateEnum": {
        "class_name": "App\\Models\\Enums\\RecordStateEnum"
    },
    "RecordingTypeEnum": {
        "class_name": "App\\Models\\Enums\\RecordingTypeEnum"
    },
    "SellerMotivationEnum": {
        "class_name": "App\\Models\\Enums\\SellerMotivationEnum"
    },
    "SellingInfoTypeEnum": {
        "class_name": "App\\Models\\Enums\\SellingInfoTypeEnum"
    },
    "SnippetTypeEnum": {
        "class_name": "App\\Models\\Enums\\SnippetTypeEnum"
    },
    "SortByRecordsInFollowUpEnum": {
        "class_name": "App\\Models\\Enums\\SortByRecordsInFollowUpEnum"
    },
    "StatusStateEnum": {
        "class_name": "App\\Models\\Enums\\StatusStateEnum"
    },
    "StatusTypeEnum": {
        "class_name": "App\\Models\\Enums\\StatusTypeEnum"
    },
    "StorageDiskEnum": {
        "class_name": "App\\Models\\Enums\\StorageDiskEnum"
    },
    "TaggableTypeEnum": {
        "class_name": "App\\Models\\Enums\\TaggableTypeEnum"
    },
    "TaskStatusEnum": {
        "class_name": "App\\Models\\Enums\\TaskStatusEnum"
    },
    "TemperatureEnum": {
        "class_name": "App\\Models\\Enums\\TemperatureEnum"
    },
    "ThrottleTypeEnum": {
        "class_name": "App\\Models\\Enums\\ThrottleTypeEnum"
    },
    "UnitedStatesStatesEnum": {
        "class_name": "App\\Models\\Enums\\UnitedStatesStatesEnum"
    },
    "UserDefinedFollowUpSequenceStepTypeEnum": {
        "class_name": "App\\Models\\Enums\\UserDefinedFollowUpSequenceStepTypeEnum"
    },
    "WebhookLogStatusEnum": {
        "class_name": "App\\Models\\Enums\\WebhookLogStatusEnum"
    },
    "WebhookLogTypeEnum": {
        "class_name": "App\\Models\\Enums\\WebhookLogTypeEnum"
    },
    "WebhookTypeEnum": {
        "class_name": "App\\Models\\Enums\\WebhookTypeEnum"
    },
    "WholesaleSellingInfoStatusEnum": {
        "class_name": "App\\Models\\Enums\\WholesaleSellingInfoStatusEnum"
    },
    "File": {
        "class_name": "App\\Models\\File"
    },
    "FixAndFlipAnalysis": {
        "class_name": "App\\Models\\FixAndFlipAnalysis"
    },
    "FixAndFlipSellingInfo": {
        "class_name": "App\\Models\\FixAndFlipSellingInfo"
    },
    "FollowUpSequence": {
        "class_name": "App\\Models\\FollowUpSequence"
    },
    "FollowUpSequenceStep": {
        "class_name": "App\\Models\\FollowUpSequenceStep"
    },
    "FollowUpSequenceStepTemplate": {
        "class_name": "App\\Models\\FollowUpSequenceStepTemplate"
    },
    "FollowUpSequenceTemplate": {
        "class_name": "App\\Models\\FollowUpSequenceTemplate"
    },
    "Import": {
        "class_name": "App\\Models\\Import"
    },
    "InstalledShareableAsset": {
        "class_name": "App\\Models\\InstalledShareableAsset"
    },
    "Integration": {
        "class_name": "App\\Models\\Integration"
    },
    "IntegrationPhoneNumber": {
        "class_name": "App\\Models\\IntegrationPhoneNumber"
    },
    "Invoice": {
        "class_name": "App\\Models\\Invoice"
    },
    "CallScriptStepFieldJson": {
        "class_name": "App\\Models\\Json\\CallScriptStepFieldJson"
    },
    "CustomFieldJson": {
        "class_name": "App\\Models\\Json\\CustomFieldJson"
    },
    "CustomFieldJsonCollection": {
        "class_name": "App\\Models\\Json\\CustomFieldJsonCollection"
    },
    "ForwarderJson": {
        "class_name": "App\\Models\\Json\\ForwarderJson"
    },
    "JsonModel": {
        "class_name": "App\\Models\\Json\\JsonModel"
    },
    "JsonModelCollection": {
        "class_name": "App\\Models\\Json\\JsonModelCollection"
    },
    "ShareableAssetJson": {
        "class_name": "App\\Models\\Json\\ShareableAssetJson"
    },
    "ShareableAssetJsonCollection": {
        "class_name": "App\\Models\\Json\\ShareableAssetJsonCollection"
    },
    "MaintenanceProcess": {
        "class_name": "App\\Models\\MaintenanceProcess"
    },
    "ManageUsersAutomation": {
        "class_name": "App\\Models\\ManageUsersAutomation"
    },
    "Market": {
        "class_name": "App\\Models\\Market"
    },
    "Note": {
        "class_name": "App\\Models\\Note"
    },
    "Notification": {
        "class_name": "App\\Models\\Notification"
    },
    "NotificationSetting": {
        "class_name": "App\\Models\\NotificationSetting"
    },
    "NotifyUsersAutomation": {
        "class_name": "App\\Models\\NotifyUsersAutomation"
    },
    "Onboarding": {
        "class_name": "App\\Models\\Onboarding"
    },
    "PendingFollowUpSequenceStep": {
        "class_name": "App\\Models\\PendingFollowUpSequenceStep"
    },
    "PhoneAgent": {
        "class_name": "App\\Models\\PhoneAgent"
    },
    "PipelineView": {
        "class_name": "App\\Models\\PipelineView"
    },
    "Property": {
        "class_name": "App\\Models\\Property"
    },
    "Record": {
        "class_name": "App\\Models\\Record"
    },
    "RecordPreview": {
        "class_name": "App\\Models\\RecordPreview"
    },
    "RecordStatus": {
        "class_name": "App\\Models\\RecordStatus"
    },
    "RecordStatusTimeAutomation": {
        "class_name": "App\\Models\\RecordStatusTimeAutomation"
    },
    "RecordUserViewed": {
        "class_name": "App\\Models\\RecordUserViewed"
    },
    "Recording": {
        "class_name": "App\\Models\\Recording"
    },
    "SalesTaxInfoState": {
        "class_name": "App\\Models\\SalesTaxInfoState"
    },
    "SchemaBuilder": {
        "class_name": "App\\Models\\Schema\\SchemaBuilder"
    },
    "SendWebhookAutomation": {
        "class_name": "App\\Models\\SendWebhookAutomation"
    },
    "AccountClosedReasonService": {
        "class_name": "App\\Models\\Services\\AccountClosedReasonService"
    },
    "AccountService": {
        "class_name": "App\\Models\\Services\\AccountService"
    },
    "AccountVerificationService": {
        "class_name": "App\\Models\\Services\\AccountVerificationService"
    },
    "ActivityService": {
        "class_name": "App\\Models\\Services\\ActivityService"
    },
    "AddTaskAutomationService": {
        "class_name": "App\\Models\\Services\\AddTaskAutomationService"
    },
    "AnsweringSequenceService": {
        "class_name": "App\\Models\\Services\\AnsweringSequenceService"
    },
    "AnsweringSequenceStepService": {
        "class_name": "App\\Models\\Services\\AnsweringSequenceStepService"
    },
    "AppointmentAttendeeService": {
        "class_name": "App\\Models\\Services\\AppointmentAttendeeService"
    },
    "AppointmentReminderAttendeeService": {
        "class_name": "App\\Models\\Services\\AppointmentReminderAttendeeService"
    },
    "AppointmentReminderService": {
        "class_name": "App\\Models\\Services\\AppointmentReminderService"
    },
    "AppointmentService": {
        "class_name": "App\\Models\\Services\\AppointmentService"
    },
    "BillingPlanChangeLogService": {
        "class_name": "App\\Models\\Services\\BillingPlanChangeLogService"
    },
    "BuyingOfferService": {
        "class_name": "App\\Models\\Services\\BuyingOfferService"
    },
    "CallScriptService": {
        "class_name": "App\\Models\\Services\\CallScriptService"
    },
    "CallScriptStepService": {
        "class_name": "App\\Models\\Services\\CallScriptStepService"
    },
    "CallrailTextLogService": {
        "class_name": "App\\Models\\Services\\CallrailTextLogService"
    },
    "CampaignCostService": {
        "class_name": "App\\Models\\Services\\CampaignCostService"
    },
    "CampaignService": {
        "class_name": "App\\Models\\Services\\CampaignService"
    },
    "CampaignUnitCountService": {
        "class_name": "App\\Models\\Services\\CampaignUnitCountService"
    },
    "ChargeService": {
        "class_name": "App\\Models\\Services\\ChargeService"
    },
    "CommunicationLogService": {
        "class_name": "App\\Models\\Services\\CommunicationLogService"
    },
    "ContactContactTypeService": {
        "class_name": "App\\Models\\Services\\ContactContactTypeService"
    },
    "ContactService": {
        "class_name": "App\\Models\\Services\\ContactService"
    },
    "ContactTypeService": {
        "class_name": "App\\Models\\Services\\ContactTypeService"
    },
    "CustomFieldService": {
        "class_name": "App\\Models\\Services\\CustomFieldService"
    },
    "DoNotContactPhoneNumberService": {
        "class_name": "App\\Models\\Services\\DoNotContactPhoneNumberService"
    },
    "EmailAutomationService": {
        "class_name": "App\\Models\\Services\\EmailAutomationService"
    },
    "EmailLogService": {
        "class_name": "App\\Models\\Services\\EmailLogService"
    },
    "EmailSentLogService": {
        "class_name": "App\\Models\\Services\\EmailSentLogService"
    },
    "FileService": {
        "class_name": "App\\Models\\Services\\FileService"
    },
    "FixAndFlipSellingInfoService": {
        "class_name": "App\\Models\\Services\\FixAndFlipSellingInfoService"
    },
    "FollowUpSequenceService": {
        "class_name": "App\\Models\\Services\\FollowUpSequenceService"
    },
    "FollowUpSequenceStepService": {
        "class_name": "App\\Models\\Services\\FollowUpSequenceStepService"
    },
    "FollowUpSequenceStepTemplateService": {
        "class_name": "App\\Models\\Services\\FollowUpSequenceStepTemplateService"
    },
    "FollowUpSequenceTemplateService": {
        "class_name": "App\\Models\\Services\\FollowUpSequenceTemplateService"
    },
    "ImportService": {
        "class_name": "App\\Models\\Services\\ImportService"
    },
    "InstalledShareableAssetService": {
        "class_name": "App\\Models\\Services\\InstalledShareableAssetService"
    },
    "InvoiceService": {
        "class_name": "App\\Models\\Services\\InvoiceService"
    },
    "ManageUsersAutomationService": {
        "class_name": "App\\Models\\Services\\ManageUsersAutomationService"
    },
    "MarketService": {
        "class_name": "App\\Models\\Services\\MarketService"
    },
    "ModelService": {
        "class_name": "App\\Models\\Services\\ModelService"
    },
    "NoteService": {
        "class_name": "App\\Models\\Services\\NoteService"
    },
    "NotificationService": {
        "class_name": "App\\Models\\Services\\NotificationService"
    },
    "NotificationSettingService": {
        "class_name": "App\\Models\\Services\\NotificationSettingService"
    },
    "NotifyUsersAutomationService": {
        "class_name": "App\\Models\\Services\\NotifyUsersAutomationService"
    },
    "OnboardingService": {
        "class_name": "App\\Models\\Services\\OnboardingService"
    },
    "PhoneAgentService": {
        "class_name": "App\\Models\\Services\\PhoneAgentService"
    },
    "PipelineViewService": {
        "class_name": "App\\Models\\Services\\PipelineViewService"
    },
    "PropertyService": {
        "class_name": "App\\Models\\Services\\PropertyService"
    },
    "RecordService": {
        "class_name": "App\\Models\\Services\\RecordService"
    },
    "RecordStatusService": {
        "class_name": "App\\Models\\Services\\RecordStatusService"
    },
    "RecordStatusTimeAutomationService": {
        "class_name": "App\\Models\\Services\\RecordStatusTimeAutomationService"
    },
    "RecordUserViewedService": {
        "class_name": "App\\Models\\Services\\RecordUserViewedService"
    },
    "RecordingService": {
        "class_name": "App\\Models\\Services\\RecordingService"
    },
    "SalesTaxInfoStateService": {
        "class_name": "App\\Models\\Services\\SalesTaxInfoStateService"
    },
    "SendWebhookAutomationService": {
        "class_name": "App\\Models\\Services\\SendWebhookAutomationService"
    },
    "ShareableGroupEmailService": {
        "class_name": "App\\Models\\Services\\ShareableGroupEmailService"
    },
    "ShareableGroupService": {
        "class_name": "App\\Models\\Services\\ShareableGroupService"
    },
    "SnippetService": {
        "class_name": "App\\Models\\Services\\SnippetService"
    },
    "StatusService": {
        "class_name": "App\\Models\\Services\\StatusService"
    },
    "SubscriptionCancelledReasonService": {
        "class_name": "App\\Models\\Services\\SubscriptionCancelledReasonService"
    },
    "TagService": {
        "class_name": "App\\Models\\Services\\TagService"
    },
    "TaskService": {
        "class_name": "App\\Models\\Services\\TaskService"
    },
    "TaskTemplateService": {
        "class_name": "App\\Models\\Services\\TaskTemplateService"
    },
    "TextAutomationService": {
        "class_name": "App\\Models\\Services\\TextAutomationService"
    },
    "ThrottleLogService": {
        "class_name": "App\\Models\\Services\\ThrottleLogService"
    },
    "UpdateRecordTemperatureAutomationService": {
        "class_name": "App\\Models\\Services\\UpdateRecordTemperatureAutomationService"
    },
    "UserService": {
        "class_name": "App\\Models\\Services\\UserService"
    },
    "WebhookLogService": {
        "class_name": "App\\Models\\Services\\WebhookLogService"
    },
    "WebhookService": {
        "class_name": "App\\Models\\Services\\WebhookService"
    },
    "WebhookSubmissionService": {
        "class_name": "App\\Models\\Services\\WebhookSubmissionService"
    },
    "WholesaleAnalysisService": {
        "class_name": "App\\Models\\Services\\WholesaleAnalysisService"
    },
    "WholesaleSellingInfoService": {
        "class_name": "App\\Models\\Services\\WholesaleSellingInfoService"
    },
    "ShareableGroup": {
        "class_name": "App\\Models\\ShareableGroup"
    },
    "ShareableGroupEmail": {
        "class_name": "App\\Models\\ShareableGroupEmail"
    },
    "Snippet": {
        "class_name": "App\\Models\\Snippet"
    },
    "Status": {
        "class_name": "App\\Models\\Status"
    },
    "SubscriptionCancelledReason": {
        "class_name": "App\\Models\\SubscriptionCancelledReason"
    },
    "Tag": {
        "class_name": "App\\Models\\Tag"
    },
    "Task": {
        "class_name": "App\\Models\\Task"
    },
    "TaskTemplate": {
        "class_name": "App\\Models\\TaskTemplate"
    },
    "TextAutomation": {
        "class_name": "App\\Models\\TextAutomation"
    },
    "ThrottleLog": {
        "class_name": "App\\Models\\ThrottleLog"
    },
    "UpdateRecordTemperatureAutomation": {
        "class_name": "App\\Models\\UpdateRecordTemperatureAutomation"
    },
    "User": {
        "class_name": "App\\Models\\User"
    },
    "UserInvite": {
        "class_name": "App\\Models\\UserInvite"
    },
    "Webhook": {
        "class_name": "App\\Models\\Webhook"
    },
    "WebhookLog": {
        "class_name": "App\\Models\\WebhookLog"
    },
    "WebhookSubmission": {
        "class_name": "App\\Models\\WebhookSubmission"
    },
    "WholesaleAnalysis": {
        "class_name": "App\\Models\\WholesaleAnalysis"
    },
    "WholesaleSellingInfo": {
        "class_name": "App\\Models\\WholesaleSellingInfo"
    }
}